import React from 'react';
import { Link } from 'react-router-dom';

const PageNotFound = () => {
    return (
        <div id='pageNotFoundPage'>
            <div style={{
                
            }}>
                <div style={styles.wrapper}>
                    <h1 style={styles.glitch}>Oops! 404</h1>
                    <p style={styles.text}>We can't find the page you're looking for.</p>
                    <Link to="/" style={styles.link}>Click here to go back to Home.</Link>
                </div>
            </div>
        </div>
    );
};

const styles = {
    wrapper: {
        fontFamily: 'Press Start 2P, cursive',
        backgroundColor: '#000',
        color: '#0f0',
        textAlign: 'center',
        height: '100vh',
        paddingTop: '15vh',
    },
    glitch: {
        fontSize: '3rem',
        marginBottom: '2rem'
    },
    text: {
        fontSize: '1.25rem',
        marginBottom: '1rem'
    },
    link: {
        color: '#0ff',
        textDecoration: 'none'
    }
};

export default PageNotFound;